import { type ChangeEvent, useEffect, useState } from 'react'
import { type ApiCbrRate, type ApiMe, fetchCbrRate } from '@/fetcher'
import { useNav } from '@/nav'
import { TeamRateForm } from './TeamRateForm'

type RateSettingsPageProps = {
  me: ApiMe
  isAdmin: boolean
}

export const RateSettingsPage = ({ me, isAdmin }: RateSettingsPageProps) => {
  const { navigate } = useNav()
  const [cbrRate, setCbrRate] = useState<ApiCbrRate | null>(null)
  const [selectedTeamId, setSelectedTeamId] = useState('')

  useEffect(() => {
    if (!isAdmin) return
    void fetchCbrRate()
      .then(setCbrRate)
      .catch(() => setCbrRate(null))
  }, [isAdmin])

  useEffect(() => {
    if (me.teams.length === 1 && me.teams[0]?.id) {
      setSelectedTeamId(me.teams[0].id)
    }
  }, [me.teams])

  const handleTeamSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    setSelectedTeamId(event.currentTarget.value)
  }

  return (
    <div className="py-8 mx-auto max-w-2xl px-4 space-y-4">
      <div className="space-y-2">
        {isAdmin && (
          <button
            type="button"
            onClick={() => navigate('agency-order')}
            className="w-full rounded-[18px] bg-[var(--app-input)] px-4 py-3 text-sm font-semibold text-[var(--app-text)] transition hover:opacity-90"
          >
            Сформировать поручение
          </button>
        )}
      </div>

      {isAdmin && (
        <>
          <div className="space-y-2">
            <label
              className="block text-sm font-medium text-[var(--app-text)]"
              htmlFor="rate-team"
            >
              Команда
            </label>

            <div className="relative">
              <select
                className="w-full appearance-none rounded-[22px] bg-[var(--app-input)] px-4 py-3 pr-12 text-sm leading-6 text-[var(--app-text)] outline-none transition focus:border-[var(--app-accent)] focus:ring-4 focus:ring-[var(--app-accent-soft)]"
                id="rate-team"
                value={selectedTeamId}
                onChange={handleTeamSelect}
              >
                <option value="">Выберите команду</option>
                {me.teams.map((team) => (
                  <option key={team.id} value={team.id}>
                    {team.name}
                  </option>
                ))}
              </select>

              <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-[var(--app-muted)]">
                ↓
              </span>
            </div>
          </div>

          {selectedTeamId && (
            <TeamRateForm
              key={selectedTeamId}
              teamId={selectedTeamId}
              cbrRate={cbrRate}
            />
          )}
        </>
      )}
    </div>
  )
}
